import React from "react";

import { LoadingPrompt } from "@itwin/core-react";

export class cLoader {
  public static getLoader(): React.ReactNode {
    return (
      <div>
        <img src="./image/geminai_logo.png" width="250px" />
        <LoadingPrompt message="Loading model..." />
      </div>
    );
  }
}
